module.exports = __webpack_public_path__ + "static/media/partitionMainImg.f8c092e6.png";